import { createPortal } from 'react-dom';
import {
  StyledTutorialArrow
} from './TutorialArrow.styled';
import { useEffect, useState } from 'react';

const calculatePosition = (selector) => {
  const anchorElement = document.querySelector(selector);
  if (anchorElement) {
    const targetRect = anchorElement.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let position = 'right';
    if (targetRect.left > viewportWidth / 2) {
      position = 'left';
    }
    let targetHeight = targetRect.bottom - targetRect.top;

    const topOffset = `calc(${targetRect.top + targetHeight/2}px - 2rem)`;
    const leftOffset = position === 'right'
      ? `${targetRect.right}px`
      : `calc(${targetRect.left}px - 4rem)`;
    const rotation = position === 'right'
      ? 'rotate(0deg)'
      : 'rotate(180deg)';
    return { top: topOffset, left: leftOffset, transform: rotation };
  } else {
    return { top: '-4rem', left: '-4rem' };
  }
}

const TutorialArrow = ({ selector }) => {
  const [position, setPosition] = useState(calculatePosition(selector));

  useEffect(() => {
    setPosition(calculatePosition(selector));
  }, [selector]);

  return createPortal(
    <StyledTutorialArrow key={position} style={{ ...position }}>
      <img src='/assets/tut_arrow.svg' />
    </StyledTutorialArrow>,
    document.body
  );
};

export default TutorialArrow;
